import { render, staticRenderFns } from "./specDetails.vue?vue&type=template&id=12aeb4e0&scoped=true&"
import script from "./specDetails.vue?vue&type=script&lang=js&"
export * from "./specDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aeb4e0",
  null
  
)

component.options.__file = "specDetails.vue"
export default component.exports